module.exports = __webpack_public_path__ + "img/wallet.1d4d2c8c.svg";